module.exports = __webpack_public_path__ + "img/UNIFORM LIME.ad7688b.svg";